import React from 'react'

type EssentialInfosProps = {
  info: string | number
  label: string
}

const EssentialInfos: React.FC<EssentialInfosProps> = ({ info, label }) => (
  <div className="flex flex-col items-center pb-2">
    <div className="text-2xl ">{info}</div>
    <div className="text-sm text-center">{label}</div>
  </div>
)

export default EssentialInfos
